import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Tag, Space, Input, Table, Select } from "antd";
import {
  FileDoneOutlined,
  CheckCircleOutlined,
  SearchOutlined,
  ClockCircleOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import http from "../../../services/http";
const { Text } = Typography;

export const AvaliacoesFormulariosRelatorioPendencias = () => {
  const { id_avaliacao_formulario, id_avaliacao } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // DADOS
  const [dados, setDados] = useState([]);
  const [avaliacaoFormulario, setAvaliacaoFormulario] = useState({});

  // DADOS FILTROS
  const [filiais, setFiliais] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [setores, setSetores] = useState([]);

  // FILTRO
  const [search, setSearch] = useState("");
  const [filialSelected, setFilialSelected] = useState(0);
  const [cargoSelected, setCargoSelected] = useState(0);
  const [setorSelected, setSetorSelected] = useState(0);

  useEffect(() => {
    if (id_avaliacao_formulario) {
      carregarAvaliacaoFormulario(id_avaliacao_formulario);
      listarColaboradoresFormularios(id_avaliacao_formulario);
      carregarFiltros();
    }
  }, [id_avaliacao_formulario]);

  // CARREGAR FILTROS
  const carregarFiltros = async () => {
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_formularios_lancamento/listar_pendencias_filtros`, []);
    if (api.statusCode === 200) {
      // FILIAIS
      let array_filiais = [{ value: 0, label: "Todas" }];
      api?.response?.data?.filiais?.forEach((f) => {
        array_filiais.push({ label: f.descricao, value: f.id });
      });

      // SETORES
      let array_setores = [{ value: 0, label: "Todos" }];
      api?.response?.data?.setores?.forEach((s) => {
        array_setores.push({ label: s.descricao, value: s.id });
      });

      // CARGOS
      let array_cargos = [{ value: 0, label: "Todos" }];
      api?.response?.data?.cargos?.forEach((c) => {
        array_cargos.push({ label: c.descricao, value: c.id });
      });

      setFiliais(array_filiais);
      setSetores(array_setores);
      setCargos(array_cargos);
    } else {
      message.error(api.response.message);
      navigate("/avaliacoes/gestao");
    }
    setLoading(false);
  };

  // CARREGAR AVALIAÇÃO
  const carregarAvaliacaoFormulario = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_vinculo_formularios/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setAvaliacaoFormulario(api.response.data);
    } else {
      message.error(api.response.message);
      navigate("/avaliacoes/gestao");
    }
    setLoading(false);
  };

  // LISTAR
  const listarColaboradoresFormularios = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_formularios_lancamento/listar_pendencias_colaboradores/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
      navigate("/avaliacoes/gestao");
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Filial",
      dataIndex: "filial",
      sorter: (a, b) => a.filial?.localeCompare(b.filial),
    },
    {
      title: "Setor",
      dataIndex: "setor",
      sorter: (a, b) => a.setor?.localeCompare(b.setor),
    },
    {
      title: "Cargo",
      dataIndex: "cargo",
      sorter: (a, b) => a.cargo?.localeCompare(b.cargo),
    },
    {
      title: "Avaliado",
      dataIndex: "nome",
      sorter: (a, b) => a.nome?.localeCompare(b.nome),
    },
    {
      title: <ClockCircleOutlined style={{ fontSize: 16, color: "red" }} />,
      dataIndex: "total_pendentes",
      sorter: (a, b) => a.total_pendentes?.toString()?.localeCompare(b.total_pendentes?.toString()),
    },
    {
      title: <CheckCircleOutlined style={{ fontSize: 16, color: "#60b565" }} />,
      dataIndex: "total_realizados",
      sorter: (a, b) => a.total_realizados?.toString()?.localeCompare(b.total_realizados?.toString()),
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar, filial_selected, cargo_selected, setor_selected) => {
    let filteredData = dados?.filter(
      (val) =>
        val.nome?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.filial?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.setor?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.cargo?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    // FILIAL
    if (filial_selected > 0) {
      filteredData = filteredData.filter((e) => e.id_filial === filial_selected);
    }

    // SETOR
    if (setor_selected > 0) {
      filteredData = filteredData.filter((e) => e.id_setor === setor_selected);
    }

    // CARGO
    if (cargo_selected > 0) {
      filteredData = filteredData.filter((e) => e.id_cargo === cargo_selected);
    }

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search, filialSelected, cargoSelected, setorSelected) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Avaliações"
              onClickBack={() => navigate(`/avaliacoes/gestao/formularios/${id_avaliacao}`)}
            />
            <HeaderTitle
              title="Avaliados Relatório Pendências"
              subtitle={
                <Text italic>
                  <FileDoneOutlined /> <Tag>{avaliacaoFormulario?.avaliacao ?? ""}</Tag>
                  {avaliacaoFormulario?.classificacao ?? ""} - {avaliacaoFormulario?.formulario ?? ""}
                </Text>
              }
              icon={<BarChartOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical">
                <Space wrap>
                  <Space direction="vertical" size={0}>
                    <Text style={{ fontSize: 12 }} type="secondary">
                      Pesquisar:
                    </Text>
                    <Input
                      size="middle"
                      maxLength={100}
                      prefix={<SearchOutlined />}
                      className="input"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder="Pesquisar..."
                      allowClear
                    />
                  </Space>
                  <Space direction="vertical" size={0}>
                    <Text style={{ fontSize: 12 }} type="secondary">
                      Filial:
                    </Text>
                    <Select
                      defaultValue={0}
                      disabled={loading}
                      value={filialSelected}
                      style={{ width: 180, maxWidth: "100%" }}
                      onChange={(e) => setFilialSelected(e)}
                      options={filiais}
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Space>
                  <Space direction="vertical" size={0}>
                    <Text style={{ fontSize: 12 }} type="secondary">
                      Setor:
                    </Text>
                    <Select
                      defaultValue={0}
                      disabled={loading}
                      value={setorSelected}
                      style={{ width: 180, maxWidth: "100%" }}
                      onChange={(e) => setSetorSelected(e)}
                      options={setores}
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Space>
                  <Space direction="vertical" size={0}>
                    <Text style={{ fontSize: 12 }} type="secondary">
                      Cargo:
                    </Text>
                    <Select
                      defaultValue={0}
                      disabled={loading}
                      value={cargoSelected}
                      style={{ width: 180, maxWidth: "100%" }}
                      onChange={(e) => setCargoSelected(e)}
                      options={cargos}
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Space>
                </Space>
              </Space>

              <Divider />

              <Table
                rowKey="id"
                scroll={{ x: 700 }}
                loading={loading}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
                summary={() => {
                  let t_pendentes = 0;
                  let t_realizados = 0;

                  dados?.forEach(({ total_pendentes, total_realizados }) => {
                    t_pendentes += parseInt(total_pendentes);
                    t_realizados += parseInt(total_realizados);
                  });

                  return (
                    <Table.Summary.Row style={{ backgroundColor: "#f7f7f7" }}>
                      <Table.Summary.Cell colSpan={4} index={0}>
                        <Text strong>Total</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={1}>
                        <Text strong>{t_pendentes}</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={2}>
                        <Text strong>{t_realizados}</Text>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  );
                }}
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
